module.exports = __webpack_public_path__ + "img/textBtm4.3dc199f8.png";